<script>
import { getters as cityGetters } from '../../store/city.store';
import { factory as citySelectFactory } from '../City/CitySelect';

const apiUrl = '/api/v1/get_documents_by_city/';
const axios = require('axios');
const _ = require('lodash');

export default {
  el: '#docs',
  name: 'DocumentList',
  data() {
    return {
      docs: [],
      docsArchive: [],
      mode: 'tariffs',
      eventHub: null,
      userSelectedCity: null,
      showCitySelect: false,
      loader: false,
      citySelectDlg: null,
    };
  },
  computed: {
    ...cityGetters,
    selectedCity() {
      return this.userSelectedCity || { Code: cityGetters.code(), Name: cityGetters.name() };
    },
  },
  watch: {
    selectedCity(newValue) {
      if (newValue) {
        this.onCitySelect(newValue);
        this.loadDocs();
      }
    },
  },
  created() {
    if (document.querySelector('.docs__items_hidden')) {
      document.querySelector('.docs__items_hidden').classList.remove('docs__items_hidden');
    }
  },
  beforeMount() {
    if (window.location.hash === '#tariffs') {
      this.mode = 'tariffs';
    }
    if (window.location.hash === '#arhiv') {
      this.mode = 'archive';
    }
    if (window.location.hash === '#prilozheniya') {
      this.mode = 'attachments';
    }
    if (window.location.hash === '#dogovory') {
      this.mode = 'contracts';
    }

    this.citySelectDlg = citySelectFactory();
    this.citySelectDlg.$on('select', (city) => {
      this.citySelectDlg.hide();
      this.userSelectedCity = city;
    });

    this.citySelectDlg.$on('hide', () => {
      this.showCitySelect = false;
    });

    this.$root.$on('cityChanged', (city) => {
      this.citySelectDlg.hide();
      this.userSelectedCity = city;
    });

    this.loadDocs();
  },
  methods: {
    setEventHub(eventHub) {
      this.eventHub = eventHub;
    },
    loadDocs() {
      this.loader = true;
      const self = this;

      axios.get(apiUrl + this.selectedCity.Code)
        .then((result) => {
          self.docs = _.chain(result.data.items).sortBy('name').value().reverse();
          self.docsArchive = _.chain(result.data.archive).sortBy('name').value().reverse();
          this.loader = false;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    onCitySelect(city) {
      this.userSelectedCity = city;
    },
    setMode(mode) {
      this.mode = mode;
    },
    showCityDialog() {
      this.citySelectDlg.show();
    },
  },
};
</script>
